import * as React from 'react';
import { Title, Section, Container, Button } from '../modules/modules';
import { RecoverPw as RecoverPwForm } from '../components/Query/User';

class RecoverPw extends React.Component {

  public render() {
    return (
      <main>
        <Section type="recoverPw">
          <Container type="sm">
            <Title type="textPage">
              Recovery password
            </Title>
            <div className="row">
              <div className="col-12 col-md-8 offset-md-2 col-lg-4 offset-lg-4">
                <div className="recoverPw__block">
                  <RecoverPwForm />
                </div>
              </div>
            </div>
          </Container>
        </Section>
      </main>
    );
  }
}

export default RecoverPw;



// WEBPACK FOOTER //
// ./src/pages/RecoverPw.tsx